export const globalColorTokens = {
  black: {
    light: {
      "1a": "#0000000D",
      "2a": "#0000001A",
      "3a": "#00000026",
      "4a": "#00000033",
      "5a": "#0000004D",
      "6a": "#00000066",
      "7a": "#00000080",
      "8a": "#00000099",
      "9a": "#000000B3",
      "10a": "#000000CC",
      "11a": "#000000E6",
      "12a": "#000000F2",
      "13a": "#000000FF",
    },
    dark: {
      "1a": "#0000000D",
      "2a": "#0000001A",
      "3a": "#00000026",
      "4a": "#00000033",
      "5a": "#0000004D",
      "6a": "#00000066",
      "7a": "#00000080",
      "8a": "#00000099",
      "9a": "#000000B3",
      "10a": "#000000CC",
      "11a": "#000000E6",
      "12a": "#000000F2",
      "13a": "#000000FF",
    },
  },
  white: {
    light: {
      "1a": "#FFFFFF0D",
      "2a": "#FFFFFF1A",
      "3a": "#FFFFFF26",
      "4a": "#FFFFFF33",
      "5a": "#FFFFFF4D",
      "6a": "#FFFFFF66",
      "7a": "#FFFFFF80",
      "8a": "#FFFFFF99",
      "9a": "#FFFFFFB3",
      "10a": "#FFFFFFCC",
      "11a": "#FFFFFFE6",
      "12a": "#FFFFFFF2",
      "13a": "#FFFFFFFF",
    },
    dark: {
      "1a": "#FFFFFF0D",
      "2a": "#FFFFFF1A",
      "3a": "#FFFFFF26",
      "4a": "#FFFFFF33",
      "5a": "#FFFFFF4D",
      "6a": "#FFFFFF66",
      "7a": "#FFFFFF80",
      "8a": "#FFFFFF99",
      "9a": "#FFFFFFB3",
      "10a": "#FFFFFFCC",
      "11a": "#FFFFFFE6",
      "12a": "#FFFFFFF2",
      "13a": "#FFFFFFFF",
    },
  },
  gray: {
    light: {
      0: "#FFFFFF",
      1: "#FCFCFC",
      2: "#F9F9F9",
      3: "#F0F0F0",
      4: "#E8E8E8",
      5: "#E0E0E0",
      6: "#D9D9D9",
      7: "#CECECE",
      8: "#BBBBBB",
      9: "#8D8D8D",
      10: "#838383",
      11: "#646464",
      12: "#202020",
      13: "#000000",
      "0a": "#00000000",
      "1a": "#00000003",
      "2a": "#00000006",
      "3a": "#0000000F",
      "4a": "#00000017",
      "5a": "#0000001F",
      "6a": "#00000026",
      "7a": "#00000031",
      "8a": "#00000044",
      "9a": "#00000072",
      "10a": "#0000007C",
      "11a": "#0000009B",
      "12a": "#000000DF",
    },
    dark: {
      0: "#0A0A0A",
      1: "#111111",
      2: "#191919",
      3: "#222222",
      4: "#2A2A2A",
      5: "#313131",
      6: "#3A3A3A",
      7: "#484848",
      8: "#606060",
      9: "#6E6E6E",
      10: "#7B7B7B",
      11: "#B4B4B4",
      12: "#EEEEEE",
      13: "#FFFFFF",
      "0a": "#FFFFFF00",
      "1a": "#FFFFFF05",
      "2a": "#FFFFFF09",
      "3a": "#FFFFFF12",
      "4a": "#FFFFFF1B",
      "5a": "#FFFFFF22",
      "6a": "#FFFFFF2C",
      "7a": "#FFFFFF3B",
      "8a": "#FFFFFF55",
      "9a": "#FFFFFF64",
      "10a": "#FFFFFF72",
      "11a": "#FFFFFFAF",
      "12a": "#FFFFFFED",
    },
  },
  red: {
    light: {
      1: "#FFFCFC",
      2: "#FFF7F7",
      3: "#FFEBE9",
      4: "#FFDBD7",
      5: "#FFCDC7",
      6: "#FFBCB6",
      7: "#F8A8A2",
      8: "#EF8D86",
      9: "#E2363C",
      10: "#D3202E",
      11: "#D2222F",
      12: "#671417",
      "1a": "#FF000003",
      "2a": "#FF000008",
      "3a": "#FF180016",
      "4a": "#FF1A0028",
      "5a": "#FF1C0038",
      "6a": "#FF150049",
      "7a": "#EC11005D",
      "8a": "#DE0F007A",
      "9a": "#DA0008C9",
      "10a": "#CD0010DF",
      "11a": "#CB000FDD",
      "12a": "#5A0003EB",
    },
    dark: {
      1: "#170F0E",
      2: "#201312",
      3: "#3C1110",
      4: "#530B0F",
      5: "#641315",
      6: "#762021",
      7: "#8F312F",
      8: "#B9413F",
      9: "#E2363C",
      10: "#BF4644",
      11: "#FF8F88",
      12: "#FFD1CC",
      "1a": "#EC000007",
      "2a": "#F22F2011",
      "3a": "#FB110C2F",
      "4a": "#FF000A47",
      "5a": "#FF171D59",
      "6a": "#FD34366D",
      "7a": "#FF4E4A87",
      "8a": "#FF5552B4",
      "9a": "#FF3B42E0",
      "10a": "#FE5956BB",
      "11a": "#FF8F88FF",
      "12a": "#FFD1CCFF",
    },
  },
  orange: {
    light: {
      1: "#FEFCFB",
      2: "#FFF7ED",
      3: "#FFEFD6",
      4: "#FFDFB5",
      5: "#FFD19A",
      6: "#FFC182",
      7: "#F5AE73",
      8: "#EC9455",
      9: "#F76B15",
      10: "#EF5F00",
      11: "#CC4E00",
      12: "#582D1D",
      "1a": "#C0400004",
      "2a": "#FF8E0012",
      "3a": "#FF9C0029",
      "4a": "#FF91014A",
      "5a": "#FF8B0065",
      "6a": "#FF81007D",
      "7a": "#ED6C008C",
      "8a": "#E35F00AA",
      "9a": "#F65E00EA",
      "10a": "#EF5F00FF",
      "11a": "#CC4E00FF",
      "12a": "#431200E2",
    },
    dark: {
      1: "#17120E",
      2: "#1E160F",
      3: "#331E0B",
      4: "#462100",
      5: "#562800",
      6: "#66350C",
      7: "#7E451D",
      8: "#A35829",
      9: "#F76B15",
      10: "#FF801F",
      11: "#FFA057",
      12: "#FFE0C2",
      "1a": "#EC360007",
      "2a": "#FE6D000E",
      "3a": "#FB6A0025",
      "4a": "#FF590039",
      "5a": "#FF61004A",
      "6a": "#FD75045C",
      "7a": "#FF832C75",
      "8a": "#FE84389D",
      "9a": "#FE6D15F7",
      "10a": "#FF801FFF",
      "11a": "#FFA057FF",
      "12a": "#FFE0C2FF",
    },
  },
  yellow: {
    light: {
      1: "#FDFDF9",
      2: "#FEFCE9",
      3: "#FFFAB8",
      4: "#FFF394",
      5: "#FFE770",
      6: "#F3D768",
      7: "#E4C767",
      8: "#D5AE39",
      9: "#FFE629",
      10: "#FFDC00",
      11: "#9E6C00",
      12: "#473B1F",
      "1a": "#AAAA0006",
      "2a": "#F4DD0022",
      "3a": "#FFEE0071",
      "4a": "#FFE3016B",
      "5a": "#FFD5008F",
      "6a": "#EBBC0097",
      "7a": "#FDCB225C",
      "8a": "#FDCA327B",
      "9a": "#FFE629FF",
      "10a": "#FFFF57FF",
      "11a": "#FEE949F5",
      "12a": "#FEF6BAF6",
    },
    dark: {
      1: "#14120B",
      2: "#1B180F",
      3: "#2D2305",
      4: "#362B00",
      5: "#433500",
      6: "#524202",
      7: "#665417",
      8: "#836A21",
      9: "#FFE629",
      10: "#FFFF57",
      11: "#F5E147",
      12: "#F6EEB4",
      "1a": "#D1510004",
      "2a": "#F9B40011",
      "3a": "#FFAA001E",
      "4a": "#FDB70028",
      "5a": "#FEBB0036",
      "6a": "#FEC40046",
      "7a": "#D2A10098",
      "8a": "#C99700C6",
      "9a": "#FFE100D6",
      "10a": "#FFDC00FF",
      "11a": "#9E6C00FF",
      "12a": "#2E2000E0",
    },
  },
  green: {
    light: {
      1: "#FBFEFC",
      2: "#F4FBF6",
      3: "#E5F7EA",
      4: "#D4F2DE",
      5: "#C1EACE",
      6: "#A9DFBC",
      7: "#88D0A2",
      8: "#52BB7F",
      9: "#00A35F",
      10: "#009555",
      11: "#008344",
      12: "#193C28",
      "1a": "#00C04004",
      "2a": "#00A32F0B",
      "3a": "#00B1321A",
      "4a": "#01B23C2B",
      "5a": "#00A9363E",
      "6a": "#00A13956",
      "7a": "#009B3877",
      "8a": "#009B43AD",
      "9a": "#00A35FFF",
      "10a": "#009555FF",
      "11a": "#008344FF",
      "12a": "#002711E6",
    },
    dark: {
      1: "#0C130E",
      2: "#121B15",
      3: "#142C1D",
      4: "#113C24",
      5: "#164A2D",
      6: "#1D5838",
      7: "#236943",
      8: "#287D4F",
      9: "#00A35F",
      10: "#009653",
      11: "#53D48C",
      12: "#AEF3C6",
      "1a": "#00BB0003",
      "2a": "#29F96E0B",
      "3a": "#2CFF7B1D",
      "4a": "#11FB792F",
      "5a": "#26FC853E",
      "6a": "#39FD934D",
      "7a": "#41FD975F",
      "8a": "#44FF9A74",
      "9a": "#00FE8F9D",
      "10a": "#00FF878F",
      "11a": "#62FFA7D1",
      "12a": "#B6FECFF3",
    },
  },
  blue: {
    light: {
      1: "#FCFDFF",
      2: "#F5FAFF",
      3: "#EAF2FF",
      4: "#DAEAFF",
      5: "#C8E0FF",
      6: "#B4D2FF",
      7: "#98BFFF",
      8: "#73A5FF",
      9: "#004CFF",
      10: "#0243DE",
      11: "#1152EC",
      12: "#0E2B6C",
      "1a": "#0055FF03",
      "2a": "#0080FF0A",
      "3a": "#0062FF15",
      "4a": "#006FFF25",
      "5a": "#0070FF37",
      "6a": "#0167FF4B",
      "7a": "#0061FF67",
      "8a": "#005BFF8C",
      "9a": "#004CFFFF",
      "10a": "#0042DEFD",
      "11a": "#0046EBEE",
      "12a": "#001F63F1",
    },
    dark: {
      1: "#091120",
      2: "#0D172B",
      3: "#0B2255",
      4: "#0B2A74",
      5: "#103489",
      6: "#18409B",
      7: "#1F4CB1",
      8: "#2458D0",
      9: "#004CFF",
      10: "#0038EE",
      11: "#89B5FF",
      12: "#CDE2FF",
      "1a": "#0011F211",
      "2a": "#0048FE1C",
      "3a": "#004DFF49",
      "4a": "#034DFD6B",
      "5a": "#1057FF81",
      "6a": "#1E62FF94",
      "7a": "#2568FEAC",
      "8a": "#296AFFCD",
      "9a": "#004CFFFF",
      "10a": "#003BFFED",
      "11a": "#89B5FFFF",
      "12a": "#CDE2FFFF",
    },
  },
  purple: {
    light: {
      1: "#FDFCFD",
      2: "#FBF7FF",
      3: "#F6EDFF",
      4: "#EFE2FF",
      5: "#E8D4FF",
      6: "#DDC3FF",
      7: "#CFADFA",
      8: "#BD8FF4",
      9: "#873ACB",
      10: "#7929BA",
      11: "#8438C7",
      12: "#431869",
      "1a": "#5500FF03",
      "2a": "#8000FF08",
      "3a": "#8000FF12",
      "4a": "#7300FF1D",
      "5a": "#7701FF2B",
      "6a": "#6F00FF3C",
      "7a": "#6A00F052",
      "8a": "#6900E670",
      "9a": "#6400BCC5",
      "10a": "#5F00ADD6",
      "11a": "#6200B7C7",
      "12a": "#300059E7",
    },
    dark: {
      1: "#140E1A",
      2: "#1C1426",
      3: "#2D1B41",
      4: "#3B2057",
      5: "#462765",
      6: "#523174",
      7: "#653F8D",
      8: "#8352B6",
      9: "#873ACB",
      10: "#7928BB",
      11: "#D09CFF",
      12: "#EAD9FF",
      "1a": "#5E00F70A",
      "2a": "#8B33FA17",
      "3a": "#9A42FC34",
      "4a": "#A044FF4B",
      "5a": "#A850FF5A",
      "6a": "#AC5EFD6B",
      "7a": "#B36AFF85",
      "8a": "#B66FFFF1",
      "9a": "#A745FEC8",
      "10a": "#A231FEB7",
      "11a": "#D09CFFFF",
      "12a": "#EAD9FFFF",
    },
  },
};

export type PhotonGlobalColorTokenKeys = keyof typeof globalColorTokens;
